import { render, staticRenderFns } from "./UserListAdmin.vue?vue&type=template&id=06d7a485&"
import script from "./UserListAdmin.vue?vue&type=script&lang=ts&"
export * from "./UserListAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports